import { AbstractControl, ValidationErrors } from "@angular/forms";

export function dataAniversarioValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (value && value.length >= 2) {
        const dia = Number(value.substring(0, 2));
        const mes = Number(value.substring(2, 4));

        const diaValido = dia >= 1 && dia <= 31;
        const mesValido = mes >= 1 && mes <= 12;

        if (!diaValido && value.length == 2) {
            return {
                dataMesAniversario: {
                    active: true,
                    erro: 'dia',
                    mensagem: `O dia não é válido`
                }
            };
        }

        if (!mesValido && value.length == 4) {
            return {
                dataMesAniversario: {
                    active: true,
                    erro: 'mes',
                    mensagem: `O mês não é válido`
                }
            };
        }

        if (mesValido && value.length == 4) {
            const diasNoMes = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

            const isAnoBissexto = (new Date().getFullYear() % 4 === 0 && (new Date().getFullYear() % 100 !== 0 || new Date().getFullYear() % 400 === 0));
            if (isAnoBissexto) {
                diasNoMes[1] = 29;
            }

            if (dia > diasNoMes[mes - 1]) {
                return {
                    dataMesAniversario: {
                        active: true,
                        erro: 'dia',
                        mensagem: `O dia não é válido para o mês fornecido`
                    }
                };
            }
        }

        return null;
    }
    return null;
}
